const CallLogs = () => {
    return (
        <iframe src="https://wss.auttom.io/reports/" width="100%" height="100%"></iframe>
    )
}

export default CallLogs